import React from 'react';
import './image-indicator.scss';
import PropTypes from 'prop-types';
const ImageIndicator = ({ count, activeIndex, cssClass = '' }) => {
  const getIndicators = () => {
    const indicators = [];
    for (let i = 0; i < count; i++) {
      const indicator = (
        <div
          key={i}
          className={`image-indicator--indicator ${
            activeIndex === i ? 'active-indicator' : ''
          } ${count === i - 1 ? 'last-indicator' : ''}`}
        />
      );
      indicators.push(indicator);
    }
    return indicators;
  };

  return <div className={`image-indicator ${cssClass}`}>{getIndicators()}</div>;
};

ImageIndicator.propTypes = {
  count: PropTypes.number,
  activeIndex: PropTypes.number,
  cssClass: PropTypes.string,
};

export default ImageIndicator;
